import React from "react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";

const ForgotPasswordPage = () => {
  return (
    <>
      <div className="flex flex-col h-screen w-full items-center">
        <img src={logo} alt="logo" className="w-[50%] logo" />
        <div className="flex flex-col w-[50%] signup mt-16">
          <div className="text-[20px] text-[#2F80ED] mb-4">Forget Password</div>

          <div className="text-[14px] text-[#828282]">Email ID/Username</div>
          <input
            type="text"
            placeholder="olivia@untitledui.com"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-1"
          />
          <div className="text-[16px] my-4">
            Enter the email associated with your account and we'll send an email
            with instructions to reset the password
          </div>
          <Link to="/check-email">
            <button className="w-full border-none bg-[#2F80ED] py-[14px] text-white rounded-lg">
              Send
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
